module.exports = __webpack_public_path__ + "img/Indian-Navy.91d5e3cc.jpg";